module.exports = __webpack_public_path__ + "files/620d5f5909fea4b876a4bf86309d3e94.png";